import React, { Component } from "react";
import { bool, func, array } from "prop-types";

import PageLoading from "pages/_components/PageLoading";

class ProductList extends Component {
    static propTypes = {
        renderItem: func.isRequired,
        children: func.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        items: array,
        fetching: bool,
        fetchingWithPreviousData: bool,
    };

    static defaultProps = {
        fetching: false,
        items: [],
        fetchingWithPreviousData: false,
    };

    render() {
        const { fetching, children, items, renderItem, fetchingWithPreviousData } = this.props;
        const isEmpty = items.length === 0;
        const loading = fetchingWithPreviousData ? fetching : isEmpty && fetching;

        return <PageLoading loading={loading}>{children(items.map(renderItem), this.renderLoadMore)}</PageLoading>;
    }
}

export default ProductList;
